// extracted by mini-css-extract-plugin
export default {"container":"ViewerControls_container__ddlIb","containerMobile":"ViewerControls_containerMobile__BilSX","control":"ViewerControls_control__13tJX"};